

















































































































































































































































































































































































































































































































































































import axios from 'axios';
import dayjs from 'dayjs';
import { required } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';
import _, { Many } from 'lodash';

import {
  Component,
  Mixins,
  Watch,
} from 'vue-property-decorator';
import {
  Getter,
  Mutation,
  State,
} from 'vuex-class';

import { CrudOperation } from '@/types/CrudOperation';
import { Roles } from '@/store/profile/types';

import { graphqlEndpoints } from '@/utils/config';
import { describeOperationError, extractRemoveSupplierErrorDetail, formatRemoveSupplierError } from '@/utils/extractApiErrorMessage';
import { supplierDisplayName } from '@/utils/supplierDisplay';
import GetClientWorkTypeUnitsSupplier from '@/graphql/GetClientWorkTypeUnitsSupplier.gql';

import { differenceBetweenTime } from '@/utils/time';
import ObjectFieldNormalizer from '@/classes/normalizers/field-normalizers/ObjectFieldNormalizer';
import UserMixin from '@/mixins/UserMixin';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import SelectOptionsFetcher from '@/mixins/SelectOptionsFetcher';

import {
  like,
  and,
} from '@/classes/pimcore-filtering/Filters';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';

import WorkCollection from '@/components/ApplicationHR/WorkCollection.vue';
import BooleanField from '@/components/FormBuilder/fields/BooleanField.vue';
import TimeField from '@/components/FormBuilder/fields/TimeField.vue';
import RepeatableInputGroup from '@/components/common/RepeatableInputGroup.vue';
import CustomSelect from '@/components/FormBuilder/CustomSelect.vue';
import DateField from '@/components/FormBuilder/fields/DateField.vue';
import ObjectField from '@/components/FormBuilder/fields/ObjectField.vue';

const DATE_FORMAT = 'YYYY-MM-DD';

interface ValidationsObject {
  passed: boolean;
  validations: Record<string, any>;
}

interface RemovedSupplierRow {
  operationId: string;
  applicationId: string;
  supplierId: string;
}

const PLANNED_WORK_PARAMS = ['day_work', 'night_work'];

const workValidations = {
  $each: {
    suppliers_with_v: {
      $each: {
        actual_quantity: {
          required,
        },
        actual_size: {
          required,
        },
        actual_work_time: {
          required,
        },
      },
    },
  },
};

const additionalWorkValidations = {
  $each: {
    work_type: {
      required,
    },
    units: {
      required,
    },
    suppliers_with_v: {
      $each: {
        supplier: {
          required,
        },
        actual_quantity: {
          required,
        },
        actual_work_time: {
          required,
        },
        actual_size: {
          required,
        },
      },
    },
  },
};

const ACTUAL_FIELDS = ['actual_work_time', 'actual_quantity', 'actual_size'] as const;

const WORK_BLOCKS = [
  'night_work',
  'day_work',
  'additional_night_work',
  'additional_day_work',
] as const;

function normalizeActualsForForm(formData: Record<string, any>) {
  if (!formData) {
    return;
  }
  WORK_BLOCKS.forEach((blockKey) => {
    const operations = formData[blockKey];
    if (!operations || !operations.length) {
      return;
    }
    operations.forEach((operation: any) => {
      const suppliers = operation?.suppliers_with_v;
      if (!suppliers || !suppliers.length) {
        return;
      }
      suppliers.forEach((supplier: any) => {
        ACTUAL_FIELDS.forEach((field) => {
          const value = supplier[field];
          if (value === 0 || value === '0') {
            supplier[field] = '';
          }
        });
      });
    });
  });
}

function denormalizeActualField(value: any): number {
  if (value === '' || value === null || value === undefined) {
    return 0;
  }
  const numeric = Number(value);
  return Number.isNaN(numeric) ? 0 : numeric;
}

const suppliersWithVModel = {
  applicationId: null,
  supplier: null,
  quantity: null,
  size: null,
  actual_quantity: '',
  actual_size: '',
  actual_work_time: '',
};

const formDataWork = [{
  suppliers_with_v: [suppliersWithVModel],
  time_from: null,
  time_to: null,
  units: null,
  work_type: null,
  actual_overall_size: null,
}];

const formDataAdditionalWorkModel = {
  suppliers_with_v: [suppliersWithVModel],
  work_type: null,
};

const formDataAdditionalWork = [formDataAdditionalWorkModel];

@Component({
  components: {
    DateField,
    ObjectField,
    WorkCollection,
    BooleanField,
    TimeField,
    RepeatableInputGroup,
    CustomSelect,
  },
})
export default class ApplicationActualsEdit extends Mixins(UserMixin, SelectOptionsFetcher, EntityHelperMixin, validationMixin) {
  @State('isModalVisible', { namespace: 'entity' })
  readonly isModalVisible!: boolean;

  @Validations()
  validations = {
    formData: {
      night_work: workValidations,
      day_work: workValidations,
      additional_night_work: additionalWorkValidations,
      additional_day_work: additionalWorkValidations,
    },
  }

  saveForm = false;

  saveDialog = false;

  baselineSuppliers: RemovedSupplierRow[] = [];

  differenceBetweenTime = differenceBetweenTime;

  formDataAdditionalWorkModel = formDataAdditionalWorkModel;

  suppliersWithVModel = suppliersWithVModel;

  platformsList: Array<any> = [];

  coordinatorsList: Array<any> = [];

  formData: Record<string, any> = {
    client: {},
    coordinator: {},
    date_from: '',
    date_to: '',
    platform: {},
    night_work: _.cloneDeep(formDataWork),
    day_work: _.cloneDeep(formDataWork),
    additional_night_work: _.cloneDeep(formDataAdditionalWork),
    additional_day_work: _.cloneDeep(formDataAdditionalWork),
  }

  rules = {
    required: (value: any) => !!value || value === 0 || 'Required.',
    counter: (value: any) => value.length <= 20 || 'Max 20 characters',
  }

  selectOptions: Record<string, any[]> = {
    client: [],
    supplier: [],
    units: [],
    workType: [],
  };

  objectFieldNormalizer = new ObjectFieldNormalizer();

  booleanFields = [
    {
      label: 'Тяжелый товар',
      fieldName: 'category',
    },
    {
      label: 'Техника',
      fieldName: 'technology',
    },
    {
      label: 'ПК',
      fieldName: 'PC',
    },
  ]

  workCollections = [
    {
      name: 'night',
      formDataParam: 'night_work',
      title: 'Ночь',
      disabled: false,
      icon: 'mdi-weather-night',
      fieldComment: 'night_comment',
      defaultTime: {
        from: '20:00',
        to: '08:00',
      },
    },
    {
      name: 'day',
      formDataParam: 'day_work',
      title: 'День',
      disabled: false,
      icon: 'mdi-white-balance-sunny',
      fieldComment: 'day_comment',
      defaultTime: {
        from: '08:00',
        to: '20:00',
      },
    },
  ]

  workCollectionsValidations: Array<any> = [];

  statusApplications: Array<any> = [];

  workCollectionValidity: ValidationsObject = {
    passed: true,
    validations: {},
  };

  @Getter('getSession', { namespace: 'profile' })
  session!: Record<string, any>;

  @Mutation('setOperation', { namespace: 'entity' })
  setOperation!: (operation: CrudOperation) => void;

  @Watch('isModalVisible')
  onModalStateChange() {
    for (let i = 0; i < this.workCollections.length; i += 1) {
      this.workCollections[i].disabled = false;
    }
  }

  inputWorkType(event: any, onInput: any, workType: any, collectionData: any) {
    this.handleOnInputValidations(event, onInput, workType);
    collectionData.units = event.units;
  }

  getDeclaredHoursValue(collectionData: any, innerCollectionData: any) {
    let diff = this.differenceBetweenTime(collectionData.time_from, collectionData.time_to) / 60;
    if (diff > 6) {
      diff -= 1;
    }
    return diff * parseInt(innerCollectionData.quantity, 10);
  }

  sumArray(array: Array<any>, parameter: string) {
    if (!array || !array.length) {
      return 0;
    }
    const toNumeric = (value: any) => {
      if (value === '' || value === null || value === undefined) {
        return 0;
      }
      return parseInt(value, 10) || 0;
    };
    if (array.length === 1) {
      return toNumeric(array[0][parameter]);
    }
    return array.reduce((acc: any, curr: any) => {
      let accActualSize = 0;
      if (acc?.[parameter] !== undefined) {
        accActualSize = toNumeric(acc[parameter]);
      } else {
        accActualSize = toNumeric(acc);
      }
      const currActualSize = toNumeric(curr[parameter]);
      return accActualSize + currActualSize;
    });
  }

  get applicationDateFrom() {
    return this.$route.query.dateFrom ? new Date(this.$route.query.dateFrom.toString()) : new Date();
  }

  get applicationDateTo() {
    return this.$route.query.dateTo ? new Date(this.$route.query.dateTo.toString()) : new Date();
  }

  get applicationPlatform(): string {
    return this.$route.query.platformId.toString() || '';
  }

  get applicationClient(): string {
    return this.$route.query.clientId.toString() || '';
  }

  get applicationStatus(): string {
    return this.$route.query.statusId.toString() || '';
  }

  get applicationCoordinator(): string {
    return this.$route.query.coordinatorId.toString() || '';
  }

  get statusIsWorkIsDone(): boolean {
    return this.statusApplications.some(({ id, code }) => code === 'in_progress' && Number(id) === Number(this.applicationStatus));
  }

  get workTypeFilteredByPlatformAndClient(): any[] {
    const workType = this.getObjectFieldPropsByName('workType')?.items || [];
    return workType.filter((i) => i.client?.id && i.platform?.id
      && Number(i.client?.id) === Number(this.formData.client?.id)
      && Number(i.platform?.id) === Number(this.formData.platform?.id));
  }

  async beforeMount() {
    this.statusApplications = await this.loadStatusApplications();
    this.selectOptions = await this.getClientOptions(GetClientWorkTypeUnitsSupplier);

    const params = new URLSearchParams();
    params.append('dateFrom', dayjs(this.applicationDateFrom).format(DATE_FORMAT));
    params.append('dateTo', dayjs(this.applicationDateTo).format(DATE_FORMAT));
    params.append('platformId', this.applicationPlatform);
    params.append('clientId', this.applicationClient);
    params.append('coordinatorId', this.applicationCoordinator);
    params.append('statusId', this.applicationStatus);
    const resp = await axios.get(graphqlEndpoints.getAggregatedOperations, {
      params,
    });
    this.formData = resp?.data?.result || this.formData;
    normalizeActualsForForm(this.formData);
    this.baselineSuppliers = _.cloneDeep(this.collectPlannedSuppliersWithIds(this.formData));

    if (this.isHR) {
      this.platformsList = await this.loadPlatforms();
      const coordinatorRole = (await this.loadRoles()).find((v: any) => v.role_type === Roles.COORDINATOR);
      this.coordinatorsList = await this.loadCoordinators(coordinatorRole);
    }
  }

  async loadRoles() {
    return this.loadEntityListing('Role');
  }

  async loadPlatforms() {
    return this.loadEntityListing('PlantsHR');
  }

  async loadStatusApplications() {
    return this.loadEntityListing('StatusApplication');
  }

  async loadCoordinators(role: any) {
    if (!this.pimcoreUser || !this.pimcoreUser.id) {
      console.error('Current user doesn\'t exist in pimcore');
      return [];
    }
    const filterBuilder = new FilterBuilder();
    filterBuilder.addFilters(
      and(
        and(
          like('superior__id', this.pimcoreUser.id),
        ),
        and(
          like('role__id', role.id),
        ),
      ),
    );
    return this.loadEntityListing('User', {
      filter: filterBuilder.build(),
    });
  }

  getSupplierDisplayName(supplier: any): string {
    return supplierDisplayName(supplier, this.selectOptions.supplier);
  }

  getObjectFieldPropsByName(fieldName: string) {
    return {
      items: this.selectOptions[fieldName],
      normalizer: this.objectFieldNormalizer,
      'item-text': 'name',
      'item-value': 'id',
    };
  }

  handleOnInputValidations(value: any, onInput: any, validations: any) {
    if (validations && validations.$touch) {
      validations.$touch();
    }
    if (onInput && typeof onInput === 'function') {
      onInput(value);
    }
  }

  getValidationErrors(validations: any): Array<string> {
    const errors: Array<string> = [];
    if (!validations || validations.$error === false || validations.$invalid === false) {
      return errors;
    }
    if (validations.required === false) {
      errors.push('Обязательное поле');
    }
    return errors;
  }

  validateFormData(): ValidationsObject {
    const validations: Record<string, any> = {};
    let passed = true;
    for (let i = 0; i < this.workCollections.length; i += 1) {
      const workSpec = this.workCollections[i];
      const operationsArray = this.formData?.[workSpec.formDataParam];
      if (!operationsArray || !operationsArray.length) {
        continue;
      }
      for (let j = 0; j < operationsArray.length; j += 1) {
        const operation = operationsArray[j];
        const allErrorsPath = `${workSpec.formDataParam}_${j}`;
        for (let k = 0; k < this.workCollectionsValidations.length; k += 1) {
          const validation = this.workCollectionsValidations[k];
          const validityResp = validation.func(operation);
          const currErrorPath = `${workSpec.formDataParam}_${j}_${validation.name}`;
          if (validityResp !== true) {
            if (validityResp.type === 'error') {
              passed = false;
            }
            if (!validations[allErrorsPath]) {
              validations[allErrorsPath] = [];
            }
            validations[allErrorsPath].push(validityResp);
            validations[currErrorPath] = validityResp;
          }
        }
      }
    }
    return {
      passed,
      validations,
    };
  }

  formDataChanged(data: any, path: Many<string | number | symbol>) {
    _.set(this.formData, path, data);
    this.workCollectionValidity = this.validateFormData();
  }

  collectPlannedSuppliersWithIds(formData: Record<string, any>): RemovedSupplierRow[] {
    const result: RemovedSupplierRow[] = [];
    for (let i = 0; i < PLANNED_WORK_PARAMS.length; i += 1) {
      const param = PLANNED_WORK_PARAMS[i];
      const operations = formData[param] || [];
      for (let j = 0; j < operations.length; j += 1) {
        const suppliers = operations[j].suppliers_with_v || [];
        for (let k = 0; k < suppliers.length; k += 1) {
          const supplier = suppliers[k];
          if (
            supplier.operationId
            && supplier.applicationId
            && supplier.supplier?.id
          ) {
            result.push({
              operationId: String(supplier.operationId),
              applicationId: String(supplier.applicationId),
              supplierId: String(supplier.supplier.id),
            });
          }
        }
      }
    }
    return result;
  }

  computeRemovedSuppliers(): RemovedSupplierRow[] {
    const currentKeys = new Set(
      this.collectPlannedSuppliersWithIds(this.formData).map(
        (row) => `${row.operationId}-${row.applicationId}-${row.supplierId}`,
      ),
    );
    return this.baselineSuppliers.filter(
      (row) => !currentKeys.has(`${row.operationId}-${row.applicationId}-${row.supplierId}`),
    );
  }

  countPlannedSupplierRows(): number {
    let count = 0;
    for (let i = 0; i < PLANNED_WORK_PARAMS.length; i += 1) {
      const operations = this.formData[PLANNED_WORK_PARAMS[i]] || [];
      for (let j = 0; j < operations.length; j += 1) {
        count += (operations[j].suppliers_with_v || []).length;
      }
    }
    return count;
  }

  async onSubmit(onlySave = true) {
    this.saveForm = true;
    this.saveDialog = false;
    if (!onlySave) {
      if (this.countPlannedSupplierRows() === 0) {
        this.$bus.$emit('notification', 'Нельзя отправить заявку без поставщиков', 'warning');
        this.saveForm = false;
        return;
      }
      this.$v.$touch();
      this.workCollectionValidity = this.validateFormData();
      if (this.$v.$invalid === true || !this.workCollectionValidity.passed) {
        this.$bus.$emit('notification', 'Форма заполнения не прошла валидацию', 'warning');
        this.saveForm = false;
        return;
      }
    }

    const removed = this.computeRemovedSuppliers();
    if (removed.length > 0) {
      try {
        const removeRes = await axios.post(graphqlEndpoints.removeSupplier, { removed });
        if (!removeRes || removeRes.status < 200 || removeRes.status >= 300) {
          this.$bus.$emit(
            'notification',
            formatRemoveSupplierError(extractRemoveSupplierErrorDetail({
              status: removeRes?.status,
              data: removeRes?.data,
            })),
            'error',
          );
          this.saveForm = false;
          return;
        }
      } catch (e) {
        this.$bus.$emit(
          'notification',
          formatRemoveSupplierError(extractRemoveSupplierErrorDetail(e)),
          'error',
        );
        this.saveForm = false;
        return;
      }
    }

    const builtFormData = this.buildFormData(this.formData);
    let res;
    try {
      if (this.statusIsWorkIsDone) {
        res = await axios.post(`${graphqlEndpoints.fillApplicationActuals}?action=${onlySave === true ? 'save' : 'save_send'}`, builtFormData);
      } else {
        res = await axios.put(graphqlEndpoints.editFactualData, {
          application: builtFormData,
          comment: builtFormData.comment,
        });
      }
    } catch (e) {
      this.$bus.$emit('notification', `Факт не сохранён. ${e}`, 'error');
      this.saveForm = false;
      return;
    }
    if (res && res.status === 200) {
      this.$router.go(-1);
      this.saveForm = false;
      return;
    }
    if (this.statusIsWorkIsDone) {
      this.$bus.$emit('notification', `Факт сохранён не полностью. ${describeOperationError(res)}`, 'error');
    }
    this.saveForm = false;
  }

  buildFormData(formData: any) {
    let builtFormData = _.cloneDeep(formData);
    builtFormData = {
      ...builtFormData,
      night_work: this.buildOperations(builtFormData.night_work),
      day_work: this.buildOperations(builtFormData.day_work),
      additional_night_work: this.buildOperations(builtFormData.additional_night_work),
      additional_day_work: this.buildOperations(builtFormData.additional_day_work),
      client: this.objectFieldNormalizer.normalize(builtFormData.client),
      coordinator: this.objectFieldNormalizer.normalize(builtFormData.coordinator),
      platform: this.objectFieldNormalizer.normalize(builtFormData.platform),
    };
    return builtFormData;
  }

  buildOperations(operations: Array<any>): Array<any> | null {
    if (!operations || !operations.length) {
      return null;
    }
    return operations.map((v: any) => ({
      ...v,
      work_type: this.objectFieldNormalizer.normalize(v.work_type),
      units: this.objectFieldNormalizer.normalize(v.units),
      suppliers_with_v: this.buildSuppliers(v.suppliers_with_v),
    }));
  }

  buildSuppliers(suppliers: Array<any>): Array<any> | null {
    if (!suppliers || !suppliers.length) {
      return null;
    }
    return suppliers.map((v: any) => ({
      ...v,
      supplier: this.objectFieldNormalizer.normalize(v.supplier),
      actual_work_time: denormalizeActualField(v.actual_work_time),
      actual_quantity: denormalizeActualField(v.actual_quantity),
      actual_size: denormalizeActualField(v.actual_size),
    }));
  }

  saveApplication() {
    this.$v.$touch();
    if (this.$v.$invalid === true) {
      return;
    }
    axios.post(graphqlEndpoints.createApplication, this.formData);
  }

  previewApplication() {
    this.setOperation(CrudOperation.preview);
    this.$bus.$emit('preview', {
      data: this.formData,
    });
  }

  allowedDates(date: string) {
    const nextDate = dayjs(date).subtract(-1, 'day').valueOf();
    return nextDate >= Date.now();
  }
}
